import * as React from 'react';

import EnterpriseDescriptionPageDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseDescriptionPageDataProvider';
import { EnterpriseUserProductCourseInfoProvider } from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseUserProductInfoProvider';
import EnterpriseBffCourseDataProvider from 'bundles/unified-description-page-common/providers/enterprise/bff/EnterpriseBffCourseDataProvider';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

const EnterpriseCoursePageDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseBffCourseDataProvider>
      <EnterpriseDescriptionPageDataProvider>
        <EnterpriseUserProductCourseInfoProvider>
          <UserDataProvider>{children}</UserDataProvider>
        </EnterpriseUserProductCourseInfoProvider>
      </EnterpriseDescriptionPageDataProvider>
    </EnterpriseBffCourseDataProvider>
  );
};

export default EnterpriseCoursePageDataProvider;
